// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeaderCOD_header__3CoIQ","title":"SubHeaderCOD_title__bRxlw","small":"SubHeaderCOD_small__2yuD4","btnContainer":"SubHeaderCOD_btnContainer__MGZi5"};